import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getNestedCategory } from 'domain/categories/helpers';
import { doctypeTabLookupSelector } from 'domain/categories/selectors';
import CONST from 'domain/documents/constants';
import { documentCategorizationAllowedSelector } from 'domain/documents/selectors/documentCategorizationAllowedSelector';

type CategoryTab = { name_id: string; id: string | number };

// URL-derived in-session document-type persistence (da-19295 D10). The active type is the deepest
// URL category segment resolved against the flat tab lookup (a Financial/General tab id → its
// name_id). Given a destination category's `tabs`, resolve ITS same-type tab id so the sidebar link
// carries the selected tab across navigation — no Redux axis. Returns undefined (→ base link → All)
// when the user is not a Bookkeeper, no type is active, the destination is tab-less
// (To-Approve/publish_failed), or the active type is All.
export const useDoctypePersistence = () => {
  const allowed = useSelector(documentCategorizationAllowedSelector);
  const lookup = useSelector(doctypeTabLookupSelector);
  const deepest = getNestedCategory(useParams());
  const activeType: string | undefined = allowed && deepest ? lookup.get(String(deepest)) : undefined;

  return (tabs?: CategoryTab[] | null): string | undefined =>
    activeType === CONST.doctype.financial || activeType === CONST.doctype.general
      ? tabs?.find((tab) => tab.name_id === activeType)?.id?.toString()
      : undefined;
};
